import React, { Fragment } from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import { useStaticQuery, graphql, navigate } from "gatsby"
import PostCard from "../cards/post-card"
import { IconButton } from "@material-ui/core"
import DoubleArrow from "@material-ui/icons/DoubleArrow"

const BlogFeed = props => {
  const data = useStaticQuery(graphql`
    query BlogFeed {
      allMdx(sort: { fields: [frontmatter___date], order: DESC }, limit: 2) {
        edges {
          node {
            excerpt
            fields {
              slug
            }
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              title
              description
              thumbnail {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            timeToRead
          }
        }
      }
    }
  `)

  const posts = data.allMdx.edges

  return (
    <React.Fragment>
      <Hidden xsDown>
        <Box
          justifyContent="center"
          display="flex"
          alignItems="center"
          flex={1}
          flexDirection="column"
          minHeight="100vh"
          mt={4}
        >
          <Typography
            variant="h1"
            style={{
              fontSize: 56,
              marginTop: 10,
              textAlign: "center",
              color: "#FFF",
            }}
          >
            {"BLOG"}
          </Typography>

          <Box
            style={{
              width: 80,
              height: 3,
              backgroundColor: "#FFF",
              marginTop: 10,
            }}
          />

          <Container
            maxWidth="lg"
            style={{
              marginTop: 50,
              marginBottom: 50,
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box style={{ flexDirection: "row", display: "flex" }}>
              <Grid container spacing={1}>
                {posts.map(({ node }) => {
                  const title = node.frontmatter.title || node.fields.slug
                  return (
                    <Grid item xs={12} sm={6} md={6} key={node.fields.slug}>
                      <PostCard
                        height={"12rem"}
                        to={`blog${node.fields.slug}`}
                        title={title}
                        date={node.frontmatter.date}
                        html={node.frontmatter.description || node.excerpt}
                        timeToRead={node.timeToRead}
                        image={node.frontmatter.thumbnail.childImageSharp.fluid}
                      />
                    </Grid>
                  )
                })}
              </Grid>
            </Box>

            <IconButton
              onClick={event => {
                event.preventDefault()
                navigate(`/blog`)
              }}
              style={{ color: "#FFFF", borderRadius: 8 }}
            >
              <DoubleArrow />
            </IconButton>
          </Container>
        </Box>
      </Hidden>

      <Hidden smUp>
        <Box
          justifyContent="center"
          display="flex"
          alignItems="center"
          flex={1}
          flexDirection="column"
          minHeight="100vh"
        >
          <Typography
            variant="h1"
            style={{
              fontSize: 30,
              marginTop: 10,
              textAlign: "center",
              color: "#FFF",
            }}
          >
            {"BLOG"}
          </Typography>

          <Box
            style={{
              width: 40,
              height: 3,
              backgroundColor: "#FFF",
              marginTop: 10,
            }}
          />

          <Container
            maxWidth="lg"
            style={{
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              style={{
                flexDirection: "row",
                display: "flex",
                overflowX: "scroll",
                marginTop: 50,
              }}
            >
              {posts.map(({ node }) => {
                const title = node.frontmatter.title || node.fields.slug
                return (
                  <Fragment>
                    <Box
                      key={node.fields.slug}
                      style={{ minWidth: "90vw", marginRight: 10 }}
                    >
                      <PostCard
                        height={"12rem"}
                        to={`blog${node.fields.slug}`}
                        title={title}
                        date={node.frontmatter.date}
                        html={node.frontmatter.description || node.excerpt}
                        timeToRead={node.timeToRead}
                        image={node.frontmatter.thumbnail.childImageSharp.fluid}
                      />
                    </Box>
                  </Fragment>
                )
              })}
            </Box>

            <IconButton
              onClick={event => {
                event.preventDefault()
                navigate(`/blog`)
              }}
              style={{ color: "#FFFF", borderRadius: 8 }}
            >
              <DoubleArrow />
            </IconButton>
          </Container>
        </Box>
      </Hidden>
    </React.Fragment>
  )
}

export default BlogFeed
